<template>
  <div>
    <div
      class="ui blue icon labeled button"
      @click="test"
      v-bind:class="{ loading: loading_test }"
    >
      <i class="play icon"></i> {{ $t("execute") }}
    </div>
    <div
      class="ui message"
      v-if="testing_result"
      v-bind:class="{ error: errored, success: !errored }"
    >
      <h4 class="ui dividing header">{{ $t("execution result") }}</h4>
      <pre>{{ testing_result }}</pre>
    </div>
  </div>
</template>

<script>
import { local_api, stringify } from "@/utils";

export default {
  name: "RobotModalTesting",
  components: {},
  props: { robot_in: Object },
  data() {
    return {
      testing_result: undefined,
      loading_test: false,
      errored: false
    };
  },
  methods: {
    test() {
      let vm = this;
      vm.testing_result = undefined;
      vm.errored = false;
      vm.loading_test = true;
      local_api(vm, "post", "/robot/do-test", {
        i: vm.robot_in.uuid
      })
        .then((r) => {
          vm.testing_result = r;
          vm.errored = false;
          vm.loading_test = false;
        })
        .catch((err) => {
          vm.$alertify.error(stringify(err));
          vm.testing_result = err;
          vm.errored = true;
          vm.loading_test = false;
        });
    }
  },
  mounted() {}
};
</script>
